module.exports = __webpack_public_path__ + "static/media/integrationNew.2c79cd94.svg";